export default {
  sidebar: {
    opened: true,
    withoutAnimation: false,
  },
  device: 'desktop',
  routeRefreshToken: 0,
}
